import React from 'react';
import { toast } from 'react-toastify';
import Toast from '@plone/volto/components/manage/Toast/Toast';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { addCartItem, CART_PATHS, isCartType, useCart } from '../../cart/cart';

type BookingButtonProps = {
  children: React.ReactNode;
  className?: string;
  seminarId?: string;
  courseNumber?: string;
  topic?: string;
  startDate?: string;
  endDate?: string;
  price?: number;
  technicalType?: string;
};

const BookingButton = ({
  children,
  className = '',
  seminarId,
  courseNumber,
  topic,
  startDate,
  endDate,
  price,
  technicalType,
}: BookingButtonProps) => {
  const cartType = isCartType(technicalType) ? technicalType : null;
  const cart = useCart(cartType);
  const isInCart = Boolean(
    seminarId && cart.items.some((item) => item.seminarId === seminarId),
  );

  const addToCart = () => {
    if (
      !cartType ||
      !seminarId ||
      !addCartItem(cartType, seminarId, {
        courseNumber,
        topic,
        startDate,
        endDate,
        price,
      })
    )
      return;

    toast.success(
      <Toast
        success
        title="Warenkorb"
        content="Der Kurs wurde dem Warenkorb hinzugefügt."
      />,
    );
  };

  if (isInCart && cartType) {
    return (
      <UniversalLink className={className} href={CART_PATHS[cartType]}>
        Warenkorb anzeigen
      </UniversalLink>
    );
  }

  return (
    <button
      className={className}
      disabled={!seminarId || !cartType}
      type="button"
      onClick={addToCart}
    >
      {children}
    </button>
  );
};

export default BookingButton;
